import React from 'react';

const PassengersField = ({ passengers, counts, onCountChange, validationError }) => {
  if (!passengers || passengers.length === 0) return null;

  const order = { 'adulto': 1, 'senior': 2, 'longevo': 3 };
  const sortedPassengers = [...passengers].sort((a, b) => {
    const aKey = Object.keys(order).find(key => a.name.toLowerCase().includes(key)) || 'z';
    const bKey = Object.keys(order).find(key => b.name.toLowerCase().includes(key)) || 'z';
    return (order[aKey] || 999) - (order[bKey] || 999);
  });

  const handleInputChange = (passengerId, value) => {
    const numValue = parseInt(value, 10);
    if (!isNaN(numValue) && numValue >= 0) {
      onCountChange(passengerId, numValue);
    } else if (value === '') {
      onCountChange(passengerId, 0);
    }
  };

  return (
    <div className={`sf-passengers-content ${validationError ? 'sf-field-error' : ''}`}>
      {sortedPassengers.map((passenger) => {
        const count = counts[passenger.id] || 0;
        return (
          <div className="sf-passenger-row" key={passenger.id}>
            <span className="sf-passenger-name">{passenger.name}</span>
            <div className="sf-passenger-counter">
              <button
                type="button"
                className="sf-counter-btn"
                onClick={() => onCountChange(passenger.id, Math.max(0, count - 1))}
                disabled={count <= 0}
              >
                -
              </button>
              <input
                type="text"
                inputMode="numeric"
                className="sf-counter-value"
                value={count}
                onChange={(e) => handleInputChange(passenger.id, e.target.value)}
                onFocus={(e) => e.target.select()}
              />
              <button
                type="button"
                className="sf-counter-btn"
                onClick={() => onCountChange(passenger.id, count + 1)}
              >
                +
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PassengersField;
